import React, {useEffect} from 'react';
import styles from './SocialMediaItem.module.scss';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';
import Menu from './../../assets/images/icons/menu.svg';
import Trash from './../../assets/images/icons/black_trash.svg';
import ToggleSwitch from './../ToggleSwitch';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {socialMediaLinks} from '../../constants/socialMedia';
import {getCurrencyLabel} from '../../constants/currencies';
import {numberFollowerFormat} from '../../Helper/generalHelper';

interface ISocialMediaItem {
  id: string;
  url: string;
  orderNumber: number;
  platform: string;
  onUrlChange?: (arg1: any, arg2: any) => void;
  onDelete?: (arg: any) => void;
  index: number;
  style?: any;
  placeholder?: string;
  isVisible?: boolean;
  onVisibilityChange?: (arg: boolean, arg2: string) => void;
  parent?: string;
  description?: string;
  price?: string | number | any;
  currency?: string;
}

const SocialMediaItem = ({id, url, platform, onUrlChange, onDelete, index, style, placeholder, isVisible, onVisibilityChange, parent, description, price, currency}: ISocialMediaItem) => {
  const [socialMediaItemIcon, setSocialMediaItemIcon] = useState(socialMediaLinks.find((e: any) => e.key === platform)?.defaultIconTransparent);
  const [socialMediaItemURL, setSocialMediaItemURL] = useState(url);
  const {t} = useTranslation();

  useEffect(() => {
    setSocialMediaItemURL(url);
  }, [url]);

  const handleUrlChange = (e: any) => {
    setSocialMediaItemURL(e.target.value);
    onUrlChange && onUrlChange(e.target.value, id);
  };

  const deleteItem = async () => {
    onDelete && onDelete(id);
  };

  return (
    <div className={styles.container} id={`element_${index}`} style={style}>
      <div className={styles.left}>
        <div className={styles.menu}><img className={styles.menu_img} src={Menu} /></div>
        <div className={styles.left_middle_container}>
          <div className={styles.icon_container}><img src={socialMediaItemIcon} /></div>
          <div className={styles.social_link_container}>
            <div className={`${styles.platform} ${parent === 'rates' ? styles.platform_rates : ''}`}>{platform}</div>
            <div className={`${styles.platform_url} ${parent === 'rates' ? styles.rates_url : ''}`}>{parent === 'rates' ? description : url}</div>
          </div>
        </div>
      </div>
      <div className={styles.right}>
        {parent === 'rates' && <div className={styles.rate_amount}>{`${getCurrencyLabel(currency)} ${numberFollowerFormat(price/100)}`}</div>}
        <div className={styles.rate_action}>
        <div className={styles.visibility}>
          <ToggleSwitch value={isVisible || false} handleChange={(e: any) => {
            onVisibilityChange && onVisibilityChange(e, id);
          }} />
          {t('visibility')}
        </div>
        <div className={styles.trash} onClick={deleteItem}>
          <img src={Trash} />
          {t('delete')}
        </div>
        </div>
      </div>
      <div className={styles.right_mobile}>
        {parent === 'rates' && <div className={styles.rate_amount}>{`${getCurrencyLabel(currency)} ${numberFollowerFormat(price/100)}`}</div>}
        <div className={styles.rate_action}>
          <div className={styles.visibility} onClick={() => onVisibilityChange && onVisibilityChange(!isVisible, id)}>
            {isVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </div>
          <div className={styles.trash} onClick={deleteItem}>
            <img src={Trash} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaItem;
